export default function Transition({ state: {status, isMounted}, children}) {
  if (!isMounted) return null;
  
  return (
      <div className={`transition-component ${status}`}>
        {children}
      </div>
  );
}
